export const NON_BREAKING_SPACE = '\u00A0';

export enum LOCALES {
  EN = 'en',
  FR = 'fr',
  DEFAULT = 'fr',
}
